import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { openModal as _openModal } from '../redux/modal';
import { performApiRequest, getResultData, getApiDataRequest, invalidateApiDataRequest } from '../redux/apiData';
import { colorPalette, fonts } from '../styles/styleGuide';
import LikeIcon from './shared/icons/Like';
import { darken } from '../styles/utils';
import { fromBreakpoint } from '../styles/breakpoints';
import withMatch from '@/hocs/withMatch';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    feedbackResponseData: getResultData(state.apiData, 'postFeedback', {
      projectSlug: String(projectSlug)
    }),
    feedbackRequest: getApiDataRequest(state.apiData, 'postFeedback', {
      projectSlug: String(projectSlug)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openModal: function openModal(actions) {
      dispatch(_openModal(colorPalette.lightOrange, actions));
    },
    onSendFeedback: function onSendFeedback(projectSlug, feedbackValues) {
      dispatch(performApiRequest('postFeedback', {
        projectSlug: projectSlug
      }, _objectSpread({}, feedbackValues)));
    },
    clearRequest: function clearRequest(projectSlug) {
      dispatch(invalidateApiDataRequest('postFeedback', {
        projectSlug: projectSlug
      }));
    }
  };
};
var FeedbackBlock = /*#__PURE__*/function (_Component) {
  function FeedbackBlock() {
    var _this;
    _classCallCheck(this, FeedbackBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FeedbackBlock, [].concat(args));
    _defineProperty(_this, "state", {
      feedbackType: ''
    });
    _defineProperty(_this, "handleClick", function (feedbackType) {
      var _this$props = _this.props,
        onSendFeedback = _this$props.onSendFeedback,
        match = _this$props.match;
      _this.setState({
        feedbackType: feedbackType
      });
      onSendFeedback(String(match.params.projectSlug), {
        value: feedbackType === 'like' ? 1 : -1
      });
    });
    return _this;
  }
  _inherits(FeedbackBlock, _Component);
  return _createClass(FeedbackBlock, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        match = _this$props2.match,
        feedbackResponseData = _this$props2.feedbackResponseData,
        feedbackRequest = _this$props2.feedbackRequest,
        openModal = _this$props2.openModal,
        clearRequest = _this$props2.clearRequest;
      if (feedbackResponseData && feedbackRequest && feedbackRequest.networkStatus === 'success') {
        var feedbackId = feedbackResponseData.id;
        var feedbackType = this.state.feedbackType;
        var positive = prevProps.positive,
          negative = prevProps.negative,
          thanks = prevProps.thanks;
        if (feedbackType === 'like' || feedbackType === 'dislike') {
          openModal({
            type: 'feedback',
            componentProps: {
              feedbackId: feedbackId,
              feedbackType: feedbackType,
              positive: positive,
              negative: negative,
              thanks: thanks
            }
          });
          clearRequest(String(match.params.projectSlug));
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var question = this.props.question;
      return __jsx(Block, {
        "data-e2e-block-feedback": true,
        "data-id": "components_FeedbackBlock_Block"
      }, __jsx(Actions, {
        "data-id": "components_FeedbackBlock_Actions"
      }, __jsx(Button, {
        type: "like",
        onClick: function onClick() {
          return _this2.handleClick('like');
        },
        "data-e2e-feedback-button-like": true,
        "data-id": "components_FeedbackBlock_Button"
      }, __jsx(LikeIcon, {
        "data-id": "components_FeedbackBlock_LikeIcon"
      })), __jsx(Button, {
        type: "dislike",
        onClick: function onClick() {
          return _this2.handleClick('dislike');
        },
        "data-e2e-feedback-button-dislike": true,
        "data-id": "components_FeedbackBlock_Button"
      }, __jsx(LikeIcon, {
        "data-id": "components_FeedbackBlock_LikeIcon"
      }))), __jsx(TextContainer, {
        "data-id": "components_FeedbackBlock_TextContainer"
      }, __jsx(Title, {
        "data-id": "components_FeedbackBlock_Title"
      }, question.title), __jsx(Description, {
        "data-id": "components_FeedbackBlock_Description"
      }, question.description)));
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(FeedbackBlock));
var Actions = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  top: -20rem;\n  position: relative;\n  margin-bottom: -5rem;\n\n  ", ";\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: -10rem;\n    left: 20rem;\n  "]))), fromBreakpoint.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    left: 75rem;\n  "]))));
var Button = styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 60rem;\n  height: 60rem;\n  background-color: ", ";\n  transition: background-color 0.3s ease-in-out;\n  border-radius: 50%;\n  box-sizing: border-box;\n  border: 4rem solid #ffffff;\n  position: relative;\n  margin: 0 6rem;\n\n  > svg {\n    transition: transform 0.1s ease-in-out;\n    transform: scale(1);\n    position: relative;\n    transform-origin: center center;\n    will-change: transform;\n  }\n\n  ", ";\n\n  ", ";\n"])), colorPalette.lightBeige, function (props) {
  return props.type === 'like' ? "\n    top: -20rem;\n\n    > svg {\n      top: 2rem;\n    }\n\n    &:hover {\n      background-color: ".concat(colorPalette.darkGreen, ";\n\n      > svg {\n        transform: scale(1.1)\n      }\n    }\n\n    &:active {\n      background-color: ").concat(darken(colorPalette.darkGreen, 10), ";\n    }\n\n  ") : "\n    > svg {\n     transform: scale(1) rotate(180deg);\n     top: 4rem;\n    }\n\n    &:hover {\n      background-color: ".concat(colorPalette.darkOrange, ";\n\n      > svg {\n        transform: scale(1.1) rotate(180deg);\n      }\n    }\n\n    &:active {\n      background-color: ").concat(darken(colorPalette.darkOrange, 10), ";\n    }\n  ");
}, fromBreakpoint.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (props) {
  return props.type === 'like' ? "" : "\n      left: -25rem;\n      bottom: -30rem;\n    ";
}));
var TextContainer = styled.section(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
var Title = styled.h3(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 18rem;\n  line-height: 26rem;\n  color: #ffffff;\n  margin-top: 0;\n  margin-bottom: 5rem;\n"])), fonts.primary);
var Description = styled.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin: 0;\n  color: #ffffff;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 18rem;\n  line-height: 26rem;\n"])), fonts.primary);
var Block = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n  min-height: 100rem;\n  margin-bottom: -10rem;\n  box-sizing: border-box;\n  background-color: ", ";\n  padding: 0 20rem 20rem 20rem;\n  top: -20rem;\n\n  ", ";\n\n  ", ";\n"])), colorPalette.lightGreen, fromBreakpoint.md(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n    padding-top: 30rem;\n    padding-bottom: 30rem;\n    padding-left: 160rem;\n    padding-right: 90rem;\n  "]))), fromBreakpoint.lg(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n    padding-left: 220rem;\n    padding-right: 105rem;\n  "]))));